import { displayLocalDate } from "../../../helpers/utcUtils";
import {PRODUCT_NAME, PRODUCT_SUPPLIER, ITEM_ORIGIN, SUPPLIER_NUMBER, PRODUCT_TYPE, MANUFACTURER, ITEM_NUMBER, STOCK_MODEL_NUMBER, UPC_NUMBER, PRODUCT_CREATION_DATE, PRIVATE_BRAND_LABEL, PURCHASE_DATE, RECEIPT, CURRENT, AT_TIME_OF_INCIDENT, AT_TIME_OF_PURCHASE, HISTORICAL_BUYER, CURRENT_BUYER, PRODUCT_NOTES, PRODUCT_DEPARTMENT, OPERATION, ITEM_DESCRIPTION, ITEM_EFFECTIVE_DATE, VENDOR_NUMBER, SAMS_CATEGORY, SUPPLIER_PACK_COST, LEGAL_CONTACT, UNIT_SIZE_PER_SELL_QTY, YES, NO } from "../../../constants/constants"
import { renderTernary } from "../../../helpers/utils";
import { Operations } from "../../../axios/operations";

const stickyCellStyle = {
  style: {
    whiteSpace: "nowrap",
    position: "sticky",
    background: "white",
    left: 28,
    zIndex: 100,
    boxShadow: "8px 0px 5px 0px rgba(0,0,0,0.04)",
  }
}

const stickyHeaderStyle = {
  style: {
    whiteSpace: "nowrap",
    position: "sticky",
    left: 28,
    background: "white",
    zIndex: 101,
    boxShadow: "8px 0px 5px 0px rgba(0,0,0,0.04)"
  }
}
export const getProductListingConfig = (renderActionColumn) => {
  const styles = { style: { whiteSpace: "nowrap" } }
  return [
    {
      name: "productName",
      label: PRODUCT_NAME,
      colKey: "productName",
      options: {
        sort: true,
        display: true,
        setCellProps: () => (stickyCellStyle),
        setCellHeaderProps: () => (stickyHeaderStyle),
        customBodyRender: (value) => (value || '-'),
        customFilterListOptions: { render: (v) => `Product Name: ${v}` },
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "productSupplier",
      label: PRODUCT_SUPPLIER,
      colKey: "productSupplier",
      options: {
        sort: true,
        display: true,
        customBodyRender: (value) => (value || '-'),
        customFilterListOptions: { render: (v) => `Product Supplier: ${v}` },
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "supplierNumber",
      label: SUPPLIER_NUMBER,
      colKey: "supplierNumber",
      options: {
        sort: true,
        display: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "productType",
      label: PRODUCT_TYPE,
      colKey: "productType",
      options: {
        sort: true,
        display: true,
        customBodyRender: (value) => (value || '-')
      },
      type: "select"
    },
    {
      name: "productDepartment",
      label: PRODUCT_DEPARTMENT,
      colKey: "productDepartment",
      options: {
        sort: true,
        display: true,
        customBodyRender: (value) => (value || '-')
      },
      type: "textField"
    },
    {
      name: "manufacturer",
      label: MANUFACTURER,
      colKey: "manufacturer",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-'),
        customFilterListOptions: { render: (v) => `Manufacturer: ${v}` },
       },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "itemNumber",
      label: ITEM_NUMBER,
      colKey: "itemNumber",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-'),
        customFilterListOptions: { render: (v) => `Item Number: ${v}` },
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "itemDescription",
      label: ITEM_DESCRIPTION,
      colKey: "itemDescription",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "itemEffectiveDate",
      label: ITEM_EFFECTIVE_DATE,
      colKey: "itemEffectiveDate",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "date"
    },
    {
      name: "vendorNumber",
      label: VENDOR_NUMBER,
      colKey: "vendorNumber",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
     {
      name: "samsCategory",
      label: SAMS_CATEGORY,
      colKey: "samsCategory",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "supplierPackCost",
      label: SUPPLIER_PACK_COST,
      colKey: "supplierPackCost",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "legalContact",
      label: LEGAL_CONTACT,
      colKey: "legalContact",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "stockModelNumber",
      label: STOCK_MODEL_NUMBER,
      colKey: "stockModelNumber",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "upcNumber",
      label: UPC_NUMBER,
      colKey: "upcNumber",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-'),
        customFilterListOptions: { render: (v) => `UPC Number: ${v}` }
      },
      operation: Operations.EQ,      
      type: "textField"
    },
    {
      name: "productCreationDate",
      label: PRODUCT_CREATION_DATE,
      colKey: "productCreationDate",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => renderTernary(value, displayLocalDate(value), '-')
      },
      operation: Operations.EQ,
      type: "date"
    },
    {
      name: "purchaseDate",
      label: PURCHASE_DATE,
      colKey: "purchaseDate",
      options: {
        display : true,
        sort: true,
        customBodyRender: (value) => renderTernary(value, displayLocalDate(value), '-')
      },
      operation: Operations.EQ,
      type: "date"
    },
    {
      name: "itemOrigin",
      label: ITEM_ORIGIN,
      colKey: "itemOrigin",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "privateBrandOrLabel",
      label: PRIVATE_BRAND_LABEL,
      colKey: "privateBrandOrLabel",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },   
    {
      name: "unitSizePerSellQty",
      label: UNIT_SIZE_PER_SELL_QTY,
      colKey: "unitSizePerSellQty",
      options: {
        display: true,
        sort: true,
        setCellHeaderProps: () => ({ style: { minWidth: "150px"}}),
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "isReceipt",
      label: RECEIPT,
      colKey: "isReceipt",
      options: {
        display : true,
        sort: true,
        customBodyRender: (value) => (value === true ? YES : value === false ? NO : '-')
      },
      operation: Operations.EQ,
      type: "boolean"
    },
    {
      name: "currentProduct",
      label: CURRENT,
      colKey: "currentProduct",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "atTimeOfIncident",
      label: AT_TIME_OF_INCIDENT,
      colKey: "atTimeOfIncident",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "atTimeOfPurchase",
      label: AT_TIME_OF_PURCHASE,
      colKey: "atTimeOfPurchase",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "historicalBuyer",
      label: HISTORICAL_BUYER,
      colKey: "historicalBuyer",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "currentBuyer",
      label: CURRENT_BUYER,
      colKey: "currentBuyer",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "productNotes",
      label: PRODUCT_NOTES,
      colKey: "productNotes",
      options: {
        display : true,
        customBodyRender: (value) => (value || '-')
      },
      operation: Operations.EQ,
      type: "textField"
    },
    {
      name: "id",
      label: PRODUCT_NAME,
      colKey: "id",
      options: {
        display: false,
        customBodyRender: (value) => (value || '-')
      }
    }
  ];
};

export const addProductConfig = () => [
  {
    "required": false,
    "dataType": "Text",
    "propertyName": "productName",
    "title": "Product Name",
    "align": "left",
    "section": "Product Information",
    "value": null
  } ,
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "upcNumber",
      "title": "UPC Number",
      "description": "UPC Number.",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Select",
      "propertyName": "productType",
      "title": "Product Type",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
    {
      "required": false,
      "dataType": "Text",
      "propertyName": "productDepartment",
      "title": "Product Department",
      "description": "Product Department.",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
    {
      "required": false,
      "dataType": "Date",
      "propertyName": "productCreationDate",
      "title": "Product Creation Date",
      "description": "Product Creation Date.",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
    {
      "required": false,
      "dataType": "Text",
      "propertyName": "manufacturer",
      "title": "Manufacturer",
      "description": "Manufacturer Details.",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "productSupplier",
      "title": "Product Supplier",
      "align": "left",
      "section": "Product Information",
       "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "supplierNumber",
      "title": "Supplier Number",
      "description": "Supplier Number(s).",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
  {
    "required": false,
    "dataType": "Date",
    "propertyName": "purchaseDate",
    "title": "Purchase Date",
    "description": "Purchase Date.",
    "align": "right",
    "section": "Product Information",
    "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "itemNumber",
      "title": "Item Number",
      "description": "Item Number.",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "itemDescription",
      "title": "Item Description",
      "description": "Item Description.",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "itemOrigin",
      "title": "Item Origin",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Date",
      "propertyName": "itemEffectiveDate",
      "title": "Item Effective Date",
      "description": "Item Effective Date.",
      "align": "left",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "privateBrandOrLabel",
      "title": "Private Brand/Label",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "unitSizePerSellQty",
      "title": "Unit Size/Sell Qty",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "vendorNumber",
      "title": "Vendor Number",
      "description": "Vendor Number.",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "currentProduct",
      "title": "Current",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Boolean",
      "propertyName": "isReceipt",
      "title": "Receipt",
      "align": "right",
      "section": "Product Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "samsCategory",
      "title": "Sam's Category",
      "description": "Sam's Category.",
      "align": "left",
      "section": "Supplier Details",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "supplierPackCost",
      "title": "Supplier Pack Cost",
      "description": "Supplier Pack Cost.",
      "align": "right",
      "section": "Supplier Details",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "legalContact",
      "title": "Legal Contact",
      "description": "Legal Contact.",
      "align": "left",
      "section": "Supplier Details",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "stockModelNumber",
      "title": "Stock/Model Number",
      "description": "Stock / Model Number.",
      "align": "right",
      "section": "Supplier Details",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "historicalBuyer",
      "title": "Historical Buyer",
      "align": "left",
      "section": "Buyer Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "currentBuyer",
      "title": "Current Buyer",
      "align": "right",
      "section": "Buyer Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "atTimeOfIncident",
      "title": "At Time of Incident",
      "align": "left",
      "section": "Buyer Information",
      "value": null
  },
  {
      "required": false,
      "dataType": "Text",
      "propertyName": "atTimeOfPurchase",
      "title": "At Time of Purchase",
      "align": "right",
      "section": "Buyer Information",
      "value": null
  },
  {
    "required": false,
    "dataType": "TextArea",
    "propertyName": "productNotes",
    "title": "Product Notes",
    "displayProperty": "Editable",
    "align": "left",
    "section": "Additional Notes",
    "value": null
}
]

export const getProductType = () => ({
  range: [
    "N/A",
    "Air Compressor",
    "Air Conditioner",
    "Air Mattress",
    "Appliances/Stove/Fridge/W&D",
    "Aquarium/Fish Tank",
    "Auto/Accessories",
    "Auto/Battery Acid",
    "Auto/Freon",
    "Auto/Jacks-Stand",
    "Auto/Misc",
    "Auto/Oil Filter",
    "Auto/Oil",
    "Auto/Wax",
    "Basketball Goal",
    "Bath/Accessories",
    "Bath/Hardware",
    "Battery/Auto",
    "Battery/Charger",
    "Battery/Home",
    "Battery/Lawnmower",
    "Battery/Motorcycle",
    "Bedding",
    "Bench",
    "Beverage/Alcohol",
    "Beverage/Dairy",
    "Beverage/Diet",
    "Beverage/Juice/Tea/Water",
    "Beverage/Soda",
    "Beverage/Styrofoam Containers",
    "Bicycle Accessories",
    "Bicycle",
    "Bicycle/Assembly",
    "Bicycle/Tricycle",
    "Blood Pressure Machine",
    "Bungee Cord",
    "Camera",
    "Camera/Accessories",
    "Camera/Digital",
    "Camp Equip. / Bedding",
    "Camp Equip./Cooking",
    "Camp Equip./Lantern",
    "Camp Equip./Tents",
    "Camping Equip/Chairs",
    "Can of Pop",
    "Candle(s)",
    "Candle/Holder/Votives",
    "Chair / Lawn and Garden",
    "Chair",
    "Christmas Tree/Artificial",
    "Cleaning Prod/Bathroom",
    "Cleaning Prod/Bleach",
    "Cleaning Prod/Floor Care",
    "Cleaning Prod/Freshener",
    "Cleaning Prod/Glass",
    "Cleaning Prod/Laundry",
    "Cleaning Prod/Mildew Remover",
    "Cleaning Prod/Mop/Broom",
    "Cleaning Prod/Multi-Purpose",
    "Cleaning Prod/Oven",
    "Cleaning Prod/drain opener",
    "Clocks",
    "Clothes Dryer",
    "Clothing/Adult/Female",
    "Clothing/Adult/Male",
    "Clothing/Boys",
    "Clothing/Girls",
    "Clothing/Infants",
    "Clothing/Other",
    "Clothing/Sleepwear",
    "Clothing/Socks",
    "Coffee/Tea  Pot",
    "Computer/Accessories",
    "Computer/Hardware",
    "Cookware/Crock Pot",
    "Cookware/Fryer",
    "Cookware/Pots and Pans",
    "Cookware/Pressure Cooker",
    "Cookware/Smoker",
    "Cookware/Toaster Oven",
    "Cooler/Jug",
    "Decorations/Seasonal",
    "Dehumidifier",
    "Deicer/Spray/Liquid",
    "Dental",
    "Deodorant",
    "Drinking Glasses",
    "Drinking Glasses/Coffee Cups",
    "Electric Blanket",
    "Exercise Equip/ Abflex",
    "Exercise Equip/ Bike",
    "Exercise Equip/ Glider",
    "Exercise Equip/ Other",
    "Exercise Equip/ Treadmill",
    "Exercise Equip/ Weights-Bench",
    "Extension Cord",
    "Eye Contact/Solution",
    "Eyewear",
    "Facial Cleanser",
    "Facial",
    "Fan/Ceiling",
    "Fan/Floor",
    "Fan/Window/Box",
    "Fire Extinguisher",
    "Firearms/Air Operated",
    "Firearms/Ammunition",
    "Firearms/B. B. Gun",
    "Firearms/Black Powder",
    "Firearms/Paintball",
    "Firearms/Rifles-Pistols",
    "Fireworks",
    "Fish Tank Heater",
    "Foam Sealant",
    "Food Coverings/Foil, Wrap, etc",
    "Food/Baby",
    "Food/Bakery",
    "Food/Beef",
    "Food/Breads",
    "Food/Breakfast Bars",
    "Food/Candy",
    "Food/Cereal/Breakfast",
    "Food/Cheese",
    "Food/Chicken",
    "Food/Chip Dip/Salsa",
    "Food/Condiments",
    "Food/Crackers/Box",
    "Food/Dairy",
    "Food/Deli",
    "Food/Egg rolls",
    "Food/Fish",
    "Food/Frozen Dinner",
    "Food/Frozen veggies",
    "Food/Fruit",
    "Food/Health Bars",
    "Food/Jar/Sauce",
    "Food/Meat",
    "Food/Microwaveable",
    "Food/Non-Dairy Creamer",
    "Food/Pizza",
    "Food/Pork",
    "Food/Sandwich",
    "Food/Seafood",
    "Food/Snack Foods",
    "Food/Soup",
    "Food/Vegetables",
    "Food/W-M Snack Bar",
    "Foot Stool",
    "Foot Warmer",
    "Fuel Container/Plastic",
    "Furniture/Bed",
    "Furniture/Cabinet",
    "Furniture/Home/Chair",
    "Furniture/Outdoor/Bench",
    "Games/Other",
    "Games/Video",
    "Games/Yard/Outdoor",
    "Gas Container/Portable",
    "Gasoline",
    "Generators",
    "Go Cart",
    "Golf/Accessories",
    "Grill/Accessories",
    "Grill/Gas",
    "Gum",
    "Gym Equipment",
    "Hair Care/Accessories",
    "Hair Care/Dryer",
    "Hair Care/Hairspray",
    "Hair Care/Process/Permanent",
    "Hair Care/Process/Relaxer",
    "Hair Color/Process/Color",
    "Hair Remover",
    "Hammock",
    "Health & Beauty Care/Poligrip",
    "Heater/Electric",
    "Heater/Kerosene",
    "Heater/Propane",
    "Heater/Space",
    "Heating Pad/Lap",
    "Heating Pad/Mattress",
    "Home Decorations",
    "Hunting Equipment/Misc",
    "Infant/Bassinet/Crib",
    "Infant/Bedding",
    "Infant/Car Seat/Booster Seat",
    "Infant/Misc.",
    "Infant/Stroller",
    "Insect Fogger",
    "Insect Repellant",
    "Insect Spray",
    "Jewelry",
    "Juice",
    "Kitchen Appliance/Mixer",
    "Knife",
    "Ladder",
    "Ladder/Aluminum",
    "Ladder/Step",
    "Lamp/Floor",
    "Lamp/Other",
    "Lamp/Table",
    "Lamp/Torchiere Halogen",
    "Landscaping Items/Accessories",
    "Lawn Chemical",
    "Lawnmower/Push",
    "Lawnmower/Riding",
    "Light/Nightlight",
    "Lighter",
    "Lighting/Christmas",
    "Lighting/Florescent",
    "Luggage/Suitcases, etc.",
    "Massager/Body",
    "Massager/Chair",
    "Massager/Foot",
    "McDonalds",
    "Microwave",
    "Microwave/Accessories",
    "Mini blinds",
    "Mobile Walker",
    "Musical Instrument",
    "Nail Care",
    "Office Equipment",
    "Office Furniture",
    "Oil Filter",
    "Packaging",
    "Paint/Accessories",
    "Paint/Resin",
    "Paint/Rust Converter",
    "Paint/Sealer",
    "Patio Furniture",
    "Perfume",
    "Pet/Accessories/Toys",
    "Pet/Food",
    "Pet/Supplies",
    "Pets/Animals, Fish",
    "Pharmacy/Eye care",
    "Pharmacy/Health Aides",
    "Pharmacy/OTC Drug",
    "Pharmacy/Prescription Drug",
    "Photo/Film",
    "Picture Frame",
    "Plant",
    "Plant/Soil, etc.",
    "Polish Remover",
    "Potpourri",
    "Power Strip",
    "Power Washer",
    "RAMP/lawn & garden",
    "Rug",
    "Safe",
    "Scooter",
    "Sewing Machine",
    "Shampoo / Conditioner",
    "Shoes/Men",
    "Shoes/Slippers",
    "Shoes/Women",
    "Ski Rope & Accessories",
    "Small Appliances/Iron",
    "Snow Blower",
    "Snow Sled",
    "Soaps",
    "Sporting Goods/ Misc",
    "Spray Paint",
    "Stereo",
    "Stool",
    "Store/Floor Cleaning Equipment",
    "Sunscreen/Sun Lotion",
    "Surge Protector",
    "Swimming Pool Products",
    "Swimming Pool",
    "Swing/Porch",
    "Swing/Yard Set",
    "TLE/Service",
    "TV & VCR",
    "TV",
    "Table",
    "Telephone/cordless",
    "Tire/Auto",
    "Tire/Truck",
    "Toaster",
    "Tools Box/Chest",
    "Tools/Grinder",
    "Tools/Hand",
    "Tools/Lawn & Garden",
    "Tools/Power/Accessories",
    "Tools/Power/Saw",
    "Toys",
    "Toys/Electric/Battery",
    "Trailor/Coupling",
    "Trampoline",
    "Trash Can",
    "Tree Stand Accessories",
    "Tree Stand",
    "Tree Steps",
    "Unknown Product",
    "VCR",
    "Vacuum Cleaner",
    "Vacuum Cleaner/Wet Dry Vac",
    "Vaporizer",
    "Video",
    "Watch",
    "Water Ski Equip",
    "Weed Killer",
    "Wheel-barrow",
    "Wood (treated)",
    "hardware/metal snap hook"
  ]})